'use client';

import { useMemo } from 'react';

import { TabNavigation } from '@xtnd/web/shared/components';

import { useWriteOffTableParams } from '../../hooks';
import { useWriteOffs } from '../../queries';
import { ArWriteOffFilter } from '../../types/writeOffs';
import AllTab from './AllTab';
import ApprovedTab from './ApprovedTab';
import ProcessedTab from './ProcessedTab';
import ProposedTab from './ProposedTab';
import RejectedTab from './RejectedTab';
import EscalationTab from './EscalationTab';
import InvoiceDetailDrawer from '../appeals/InvoiceDetailDrawer';

import { InvoiceDetailProvider } from '../common/InvoiceContext';
import { useClerkUserMap } from '../../queries/userQuery';

export default function WriteOffs() {
  const isAdmin = true;

  const { tableParams, setParams, subtab, setSubtab, currentStatus } = useWriteOffTableParams();
  const { clerkUserMap, clerkColorMap } = useClerkUserMap();

  const writeOffsParams = useMemo(
    () => ({
      ...tableParams,
      filters: {
        ...tableParams.filters,
        status: currentStatus,
      } as ArWriteOffFilter & { status: typeof currentStatus },
    }),
    [tableParams, currentStatus]
  );

  const writeOffsQuery = useWriteOffs(writeOffsParams);

  // Common props passed to all tabs
  const commonTabProps = {
    isAdmin,
    tableParams: writeOffsParams,
    setTableParams: setParams,
    data: writeOffsQuery.data,
    isLoading: writeOffsQuery.isFetching,
    error: writeOffsQuery.error,
    refetch: writeOffsQuery.refetch,
  };

  const tabs = [
    {
      id: 'all',
      label: 'All',
      icon: 'HiFilter',
      content: <AllTab {...commonTabProps} />,
    },
    {
      id: 'proposed',
      label: 'Proposed',
      content: <ProposedTab {...commonTabProps} />,
    },
    {
      id: 'escalation',
      label: 'Escalation',
      content: <EscalationTab {...commonTabProps} />,
    },
    {
      id: 'approved',
      label: 'Approved',
      content: <ApprovedTab {...commonTabProps} />,
    },
    {
      id: 'rejected',
      label: 'Rejected',
      content: <RejectedTab {...commonTabProps} />,
    },
    {
      id: 'processed',
      label: 'Processed',
      content: <ProcessedTab {...commonTabProps} />,
    },
  ];

  return (
    <InvoiceDetailProvider>
      <TabNavigation className="space-y-6" tabs={tabs} activeTab={subtab} onTabChange={setSubtab} />
      <InvoiceDetailDrawer clerkUserMap={clerkUserMap} clerkColorMap={clerkColorMap} />
    </InvoiceDetailProvider>
  );
}
